import { Link } from "react-router-dom";
import { 
  FaHome, 
  FaBoxOpen, 
  FaInfoCircle, 
  FaEnvelope,
  // FaShoppingCart,
  FaChevronDown
} from "react-icons/fa";

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark shadow-sm py-3">
      <div className="container">
        {/* Brand Logo */}
        <Link to="/" className="navbar-brand fw-bold fs-4 d-flex align-items-center">
          
          <span className="text-white">JALISTEP</span>
        </Link>

        {/* Mobile Menu Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarcontents"
          aria-controls="navbarcontents"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links with Icons */}
        <div className="collapse navbar-collapse" id="navbarcontents">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item mx-2">
              <Link 
                to="/" 
                className="nav-link text-white fw-medium d-flex align-items-center"
              >
                <FaHome className="me-1" />
                <span>Home</span>
              </Link>
            </li>
            
            {/* Products Dropdown */}
            <li className="nav-item mx-2 dropdown">
              <div 
                className="nav-link text-white fw-medium d-flex align-items-center dropdown-toggle"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FaBoxOpen className="me-1" />
                <span>Products</span>
                <FaChevronDown className="ms-1" size={12} />
              </div>
              <ul className="dropdown-menu dropdown-menu-dark">
                <li><Link to="/filters" className="dropdown-item">Filters</Link></li>
                <li><Link to="/pumps" className="dropdown-item">Pumps</Link></li>
                <li><Link to="/membranes" className="dropdown-item">Membranes</Link></li>
                <li><Link to="/meters" className="dropdown-item">Meters & Gauges</Link></li>
                <li><Link to="/vessels" className="dropdown-item">FRP Vessels</Link></li>
                <li><Link to="/filtermedia" className="dropdown-item">Filter Media</Link></li>
                <li><Link to="/ro" className="dropdown-item">RO Systems</Link></li>
                <li><hr className="dropdown-divider" /></li>
                <li><Link to="/products" className="dropdown-item">All Products</Link></li>
              </ul>
            </li>

            <li className="nav-item mx-2">
              <Link 
                to="/aboutus" 
                className="nav-link text-white fw-medium d-flex align-items-center"
              >
                <FaInfoCircle className="me-1" />
                <span>About Us</span>
              </Link>
            </li>
           
            <li className="nav-item mx-2">
              <Link 
                to="/contacts" 
                className="nav-link text-white fw-medium d-flex align-items-center"
              >
                <FaEnvelope className="me-1" />
                <span>Contact Us</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;